import { useRef } from "react";
import { Volume2, VolumeX } from "lucide-react";

/**
 * Bocina: clic = mute. Hover = triángulo (fino a la izquierda, ancho a la derecha).
 * El relleno de izquierda a derecha es el volumen.
 */
export default function MediosVolumeControls({
  muted,
  volume,
  onMuteToggle,
  onVolumeLevel,
  className = "",
  buttonClass = "",
}) {
  const shown = muted ? 0 : volume;
  const trackRef = useRef(null);
  const btn =
    buttonClass ||
    "pointer-events-auto inline-flex items-center justify-center rounded-full border border-white/25 bg-black/60 text-white backdrop-blur-md hover:bg-black/80 p-2";

  const applyFromEvent = (ev) => {
    const el = trackRef.current;
    if (!el || !onVolumeLevel) return;
    const rect = el.getBoundingClientRect();
    const x = (ev.clientX ?? ev.touches?.[0]?.clientX ?? 0) - rect.left;
    const pct = Math.round((x / Math.max(rect.width, 1)) * 100);
    onVolumeLevel(pct);
  };

  const onPointerDown = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    const el = trackRef.current;
    if (!el) return;
    el.setPointerCapture?.(ev.pointerId);
    applyFromEvent(ev);
  };

  return (
    <div className={`medios-vol group/vol relative flex items-center ${className}`}>
      <button
        type="button"
        onClick={onMuteToggle}
        className={btn}
        aria-pressed={!muted}
        aria-label={muted ? "Activar sonido" : "Silenciar"}
        title={muted ? "Activar sonido" : "Silenciar"}
      >
        {muted || shown <= 0 ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      <div
        className="medios-vol__flyout pointer-events-none absolute left-full top-1/2 z-30 ml-2 -translate-y-1/2 opacity-0 transition-opacity duration-150 drop-shadow-md group-hover/vol:pointer-events-auto group-hover/vol:opacity-100 group-focus-within/vol:pointer-events-auto group-focus-within/vol:opacity-100"
      >
        <div
          ref={trackRef}
          role="slider"
          tabIndex={0}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={shown}
          aria-label="Volumen"
          className="medios-vol__wedge relative h-7 w-[5.5rem] cursor-pointer touch-none"
          onPointerDown={onPointerDown}
          onPointerMove={(ev) => {
            if (ev.buttons) applyFromEvent(ev);
          }}
        >
          <span
            className="medios-vol__shape medios-vol__shape--fill"
            style={{ width: `${shown}%` }}
            aria-hidden
          />
        </div>
      </div>
    </div>
  );
}
